import { AxiosResponse } from "axios";

export interface TeamListItem {
  id: number;
  name: string;
  members_count?: number;
}

export interface TeamMember {
  id: number;
  first_name?: string;
  email?: string;
}

export interface TeamDetail extends TeamListItem {
  members?: TeamMember[];
}

export function unwrapTeamsList(res: AxiosResponse): TeamListItem[] {
  const d = res?.data?.data;
  if (Array.isArray(d)) return d;
  if (d?.teams && Array.isArray(d.teams)) return d.teams;
  if (d?.data && Array.isArray(d.data)) return d.data;
  return [];
}

export function unwrapTeamDetail(res: AxiosResponse): TeamDetail | null {
  const d = res?.data?.data ?? res?.data;
  if (!d || typeof d !== "object") return null;
  const t = d as TeamDetail & { users?: TeamMember[] };
  if (!t.members?.length && Array.isArray(t.users)) {
    t.members = t.users;
  }
  return t;
}
